<script setup lang="ts">

import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppText } from '@shared/ui/typography'
import { BtnLink } from '@shared/ui/links'

import { useTutorKanbanLinks } from '../model/use-tutor-kanban-links.hook'

defineOptions({
  name: 'TutorKanbanLinks',
})

const {
  refTutorAppLink,
  refDiscordLink,
  refRespondLink,
} = useTutorKanbanLinks()
</script>

<template>
  <div class="tutor-links">
    <AppText name="body1-medium">
      Links
    </AppText>
    <div class="tutor-links__wrapper">
      <BtnLink
        :link-url="refTutorAppLink"
        link-name="Tutor schedule"
      />
      <BtnLink
        :link-url="refDiscordLink"
        link-name="Discord"
      >
        <template #iconLeft>
          <FontAwesomeIcon :icon="faDiscord" />
        </template>
      </BtnLink>
      <BtnLink
        :link-url="refTutorAppLink"
        link-name="Act on behalf"
        hide-copy
      />
      <BtnLink
        :link-url="refRespondLink"
        link-name="Respond"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanLinks.scss" />
